// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});


// Smooth Scroll Animation


// SEARCH
$('.user-icons').on("click", function (e) {
    $('#search-pop').hide();
});


$("body").on("click", '.js-show-search, .search-close', function (e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if ($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }

    $('#search-pop').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});





$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,

            }
        }
    ]

});




// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    touchThreshold: 10,
    asNavFor: '.js-slider-thumbs',
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                fade: false,
                variableWidth: true
            }
        }
    ]
});
$('.js-slider-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 6,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: false,
    touchThreshold: 15,
    variableWidth: false,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true
});

$('.promotions-container').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: 'linear',
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: false,
    responsive: [
        {
          breakpoint: 992,
          settings: {
            speed: 3000
          }
        }
      ]
});

$(document).ready(function() {
    function initSlick() {
        if (window.innerWidth < 992) {
            if (!$('.component-collection-grid-slider').hasClass('slick-initialized')) {
                $('.component-collection-grid-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    padding: '36px'
                });
            }
        } else {
            if ($('.component-collection-grid-slider').hasClass('slick-initialized')) {
                $('.component-collection-grid-slider').slick('unslick');
            }
        }
    }

    initSlick();

    $(window).resize(function() {
        initSlick();
    });
});

// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
              
                // Update Price
                var selected = this.options[this.selectedIndex],
                    variantPrice = selected.dataset.price;
debugger;
                $('#productPrice').text(variantPrice);

                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;

                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });

                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }


                /** Update Nutritions table tab content */
                if (this.options.length > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);


// Footer Nav

function resizeHandler() {
    console.log("window resized");

    if ($(window).width() < 767) {
        console.log("window small than 600");

        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      var scriptContainer = document.getElementById("kno-survey-script-container");
      var surveyEmbed = document.getElementById("kno-survey-embed");

      if (scriptContainer && !surveyEmbed) {
        var message = document.createElement("p");
        message.textContent = "Your response has already been recorded";
        message.style.fontWeight = "bold";
        message.style.marginTop = "10px";
        message.style.marginBottom = "20px";
        message.style.textAlign = "center";
        message.style.fontFamily = "Brown";

        scriptContainer.parentNode.insertBefore(message, scriptContainer.nextSibling);
      }
    }, 2000); // waits 2 seconds before checking
  });


  (function() {
    const gallery = document.getElementById('ProductPhotoGallery');
    if (!gallery) return;

    let isDragging = false;
    let wasDragged = false; 
    let startX, startY;
    let translateX = 0, translateY = 0;
    let lastTranslateX = 0, lastTranslateY = 0;

    gallery.addEventListener('mousedown', function(e) {
        const img = e.target.closest('img');
        if (!img || !img.classList.contains('is-zoomed')) return;

        isDragging = true;
        wasDragged = false; // Reset drag flag
        startX = e.clientX - lastTranslateX;
        startY = e.clientY - lastTranslateY;
        img.style.transition = 'none';
    });

    window.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        
        const img = gallery.querySelector('img.is-zoomed');
        if (!img) return;

        if (Math.abs(e.clientX - (startX + lastTranslateX)) > 5 || 
            Math.abs(e.clientY - (startY + lastTranslateY)) > 5) {
            wasDragged = true; 
        }

        translateX = e.clientX - startX;
        translateY = e.clientY - startY;

        img.style.transform = `scale(2.5) translate(${translateX / 2.5}px, ${translateY / 2.5}px)`;
    });

    window.addEventListener('mouseup', function(e) {
        if (!isDragging) return;
        
        isDragging = false;
        lastTranslateX = translateX;
        lastTranslateY = translateY;

        if (wasDragged) {
            e.stopPropagation();
            e.preventDefault();
        }
    });

    gallery.addEventListener('click', function(e) {
        if (wasDragged) {
            e.stopImmediatePropagation();
            e.preventDefault();
            wasDragged = false; // Reset for next time
            return false;
        }

        const img = e.target.closest('img');
        if (!img) return;

        if (img.classList.contains('is-zoomed')) {
            // Zoom Out logic
            img.classList.remove('is-zoomed');
            img.style.transform = 'scale(1) translate(0px, 0px)';
            img.style.transition = 'transform 0.3s ease';
            translateX = translateY = lastTranslateX = lastTranslateY = 0;
        } else {
            // Zoom In logic
            img.classList.add('is-zoomed');
            img.style.transform = 'scale(2.5) translate(0px, 0px)';
            img.style.transition = 'transform 0.3s ease';
        }
    }, true); // 
})();